import React from 'react';

const EditSquare = () => {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Edit Square">
        <path
          id="Stroke 1"
          d="M7.619 2.59174H4.81475C2.5085 2.59174 1.0625 4.22449 1.0625 6.53599V12.7715C1.0625 15.083 2.50175 16.7157 4.81475 16.7157H11.4327C13.7465 16.7157 15.1857 15.083 15.1857 12.7715V9.75049"
          stroke="#1A1E27"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Stroke 3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.62097 7.69068L12.2257 2.08593C12.924 1.38843 14.0557 1.38843 14.754 2.08593L15.6667 2.99868C16.365 3.69693 16.365 4.82943 15.6667 5.52693L10.035 11.1587C9.72972 11.4639 9.31572 11.6357 8.88372 11.6357H6.07422L6.14472 8.80068C6.15522 8.38368 6.32547 7.98618 6.62097 7.69068Z"
          stroke="#1A1E27"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Stroke 5"
          d="M11.373 2.95148L14.7975 6.37598"
          stroke="#1A1E27"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default EditSquare;
